import { MEMBER_STATUS } from '../constants/copy.js';
import { getMemberDisplayName } from './memberDisplay.js';
import { getEffectiveStatus } from './memberStatus.js';

/** API statuses are snake_case; the vocabulary (`MEMBER_STATUS`) is camelCase. */
const API_STATUS_TO_UI = Object.freeze({
  active: MEMBER_STATUS.ACTIVE,
  invited: MEMBER_STATUS.INVITED,
  expired: MEMBER_STATUS.EXPIRED,
  not_invited: MEMBER_STATUS.NOT_INVITED,
  notInvited: MEMBER_STATUS.NOT_INVITED,
  suspended: MEMBER_STATUS.SUSPENDED,
  removed: MEMBER_STATUS.REMOVED,
});

/** The other way round: the status value the service filters by. */
export const UI_STATUS_TO_API = Object.freeze({
  ...Object.fromEntries(Object.entries(API_STATUS_TO_UI).filter(([key]) => key !== 'notInvited').map(([api, ui]) => [ui, api])),
});

/**
 * Header cards: snake_case counts to the camelCase UI model. The total is rendered as the
 * API returns it (no client-side math).
 */
export const mapApiMemberStatsToUi = (api = {}) => ({
  activeCount: api.active ?? api.activeCount ?? 0,
  totalCount: api.total ?? api.totalCount ?? 0,
  pendingCount: api.pending_invitations ?? api.pendingCount ?? 0,
  notSentCount: api.not_sent ?? api.notSentCount ?? 0,
  activeWithoutMfaCount: api.active_without_mfa ?? api.activeWithoutMfaCount ?? 0,
});

/** One member (list row or detail): snake_case (or camelCase) API member to the UI model. */
export const mapApiMemberToUi = (api) => {
  const status = API_STATUS_TO_UI[api.status] ?? api.status;
  const expiresAt = api.invitation_expires_at ?? api.invitationExpiresAt ?? null;

  return {
    id: api.id,
    name: api.name ?? '',
    displayName: getMemberDisplayName({
      name: api.name ?? api.display_name ?? api.displayName,
      email: api.email,
    }),
    email: api.email,
    userType: api.user_type ?? api.userType,
    status: getEffectiveStatus({ status, expiresAt }),
    mfaEnabled: api.mfa_enabled ?? api.mfaEnabled ?? false,
    lastActiveAt: api.last_active_at ?? api.lastActiveAt ?? null,
    addedAt: api.added_at ?? api.addedAt ?? null,
    jobTitle: api.job_title ?? api.jobTitle ?? null,
    department: api.department ?? '',
    invitedAt: api.invited_at ?? api.invitedAt ?? null,
    invitationExpiresAt: expiresAt,
    roles: api.roles ?? [],
    groups: api.groups ?? [],
    roleIds: api.role_ids ?? api.roleIds ?? [],
    groupIds: api.group_ids ?? api.groupIds ?? [],
    importBatchId: api.import_batch_id ?? api.importBatchId ?? null,
  };
};
